import localSave from './../utils/local-save'
import { onDemandQualityOptions as options } from "./../configuration"

const optionsEnum = {
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high'
}

class SettingsService {
    static instance = null

    constructor() {
        if (SettingsService.instance) return SettingsService.instance
        SettingsService.instance = this
    }

    async init(isActuallyPremium = false) {
        const isSavedAsPremium = localSave.get('isPremium')
        if (isSavedAsPremium !== isActuallyPremium) {
            localSave.save('isPremium', isActuallyPremium)
            await this.setCurrentOnDemandQuality(isActuallyPremium ? optionsEnum.HIGH : optionsEnum.LOW)
        }
    }

    setCurrentOnDemandQuality(qualityKey) {
        return new Promise((resolve, reject) => {
            if (!options[qualityKey]) reject(new Error('Invalid quality option'))
            localSave.save('currentOnDemandQualityKey', qualityKey)
            resolve(options[qualityKey])
        })
    }

    getCurrentOnDemandQualityKey(isPremium = false) {
        return new Promise((resolve, reject) => {
            const qualityKey = localSave.get('currentOnDemandQualityKey')

            resolve(qualityKey)
        })
    }

    removeCurrentOnDemandQualityKey() {
        return new Promise((resolve, reject) => {
            localSave.delete('currentOnDemandQualityKey')
            resolve()
        })
    }
}

export default new SettingsService()
